import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Navbar from 'components/Navbar';
import Footer from 'components/Footer';
import { ArrowLeft, Home } from 'lucide-react';

const ErrorPage = () => {
  const { t } = useTranslation();

  return (
    <section className='relative flex flex-col min-h-screen overflow-hidden bg-white'>
      <Navbar />

      {/* BACKGROUND GRADIENT ACCENT */}

      <div
        className='absolute inset-0 flex items-center justify-center pointer-events-none '
      >
        <div
          className='
          w-[600px]
          h-[600px]
          rounded-full
          bg-gradient-to-br
          from-red-100
          via-transparent
          to-orange-100
          blur-3xl
          opacity-60
          '
        />
      </div>

      {/* BIG 404 */}

      <div
        className='
        pointer-events-none
        absolute
        inset-0
        flex
        items-center
        justify-center
        select-none
        font-bold
        tracking-tight
        text-neutral-100
        text-[160px]
        sm:text-[220px]
        md:text-[300px]
        '
      >
        404
      </div>

      {/* CONTENT */}

      <div
        className='
        relative
        flex-1
        flex
        items-center
        justify-center
        px-6
        md:px-8
        text-center
        min-h-[90vh]
        '
      >
        <div className='max-w-xl'>
          {/* LABEL */}

          <p
            className='
            text-red-500
            text-xs
            uppercase
            tracking-[0.3em]
            font-medium
            mb-6
            '
          >
            Error
          </p>

          {/* TITLE */}

          <h1
            className='
            text-[32px]
            sm:text-[40px]
            md:text-[48px]
            font-semibold
            leading-tight
            tracking-tight
            mb-6
            '
          >
            {t('error.title')}
          </h1>

          {/* DESCRIPTION */}

          <p
            className='mb-10 text-sm leading-relaxed  text-neutral-600 md:text-base'
          >
            {t('error.desc')}
          </p>

          {/* BUTTONS */}

          <div className='flex flex-wrap items-center justify-center gap-3'>
            {/* HOME */}

            <Link
              to='/'
              className='inline-flex items-center gap-2 px-6 py-3 text-sm font-medium text-white transition bg-black shadow-lg  rounded-xl hover:bg-neutral-800 hover:shadow-xl'
            >
              <Home size={16} />

              {t('error.home')}
            </Link>

            {/* BACK */}

            <button
              onClick={() => window.history.back()}
              className='inline-flex items-center gap-2 px-6 py-3 text-sm font-medium transition border  rounded-xl border-neutral-300 hover:bg-neutral-100'
            >
              <ArrowLeft size={16} />

              {t('error.back')}
            </button>
          </div>
        </div>
      </div>

      <Footer />
    </section>
  );
};

export default ErrorPage;
